<template>
  <section id="solutions" class="py-24 bg-gray-50 dark:bg-dark-bg transition-colors duration-300">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16 max-w-3xl mx-auto">
        <h2 class="text-base font-semibold text-accent tracking-wide uppercase transition-colors duration-300">{{ t('solutions.subtitle') }}</h2>
        <p class="mt-2 text-3xl font-extrabold text-gray-900 dark:text-white sm:text-4xl transition-colors duration-300">{{ t('solutions.title') }}</p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="(industry, index) in tm('solutions.industries')" :key="index" class="animate-on-scroll-right flex items-start gap-5 bg-white dark:bg-dark-surface rounded-2xl p-6 border-2 border-indigo-200 dark:border-indigo-800 hover:border-indigo-500 dark:hover:border-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-all duration-300 shadow-sm hover:shadow-md">
          <div class="w-12 h-12 bg-indigo-100 dark:bg-indigo-900/30 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-300">
            <Building2 class="w-6 h-6 text-indigo-600 dark:text-indigo-400 transition-colors duration-300" />
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2 transition-colors duration-300">{{ industry.title }}</h3>
            <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed transition-colors duration-300">{{ industry.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { Building2 } from 'lucide-vue-next'
import { useAnimateOnScroll } from '@/composables/useAnimateOnScroll'

const { t, tm } = useI18n({ useScope: 'global' })
const { observeElements } = useAnimateOnScroll(null, { animateClass: 'animate-in-right' })

onMounted(() => {
  observeElements('.animate-on-scroll-right')
})
</script>
